"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var js_cookie_1 = require("js-cookie");
var es6_promise_1 = require("es6-promise");
require("whatwg-fetch");
es6_promise_1.polyfill();
var XSRF_TOKEN_COOKIE_KEY = 'XSRF-TOKEN';
var XSRF_TOKEN_HEADER_KEY = 'X-XSRF-TOKEN';
var VIZPORTAL_WEB_CLIENT_API_PREFIX = 'vizportal/api/web/v1';
var VIZPORTAL_WEB_CLIENT_API_METHOD_NAME = 'reportEventUnauthenticated';
/**
 * Implementation of a WebClientRequester that uses the fetch API protocols
 */
var FetchRequester = /** @class */ (function () {
    function FetchRequester(endpoint) {
        this.endpoint = endpoint;
        if (typeof fetch === 'undefined' || typeof Request === 'undefined') {
            throw new Error('The fetch API is not defined in this browser. Try adding a polyfill library like "whatwg-fetch"');
        }
        // Only send the xsrf auth token if we're sending to the default vizportal endpoint
        this.sendAuthToken = this.endpoint === '' ? true : false;
    }
    FetchRequester.prototype.send = function (params) {
        var path = this.endpoint + "/" + VIZPORTAL_WEB_CLIENT_API_PREFIX + "/" + VIZPORTAL_WEB_CLIENT_API_METHOD_NAME;
        var init = {
            method: 'POST',
            headers: this.getHeaders(),
            cache: 'default',
            mode: 'cors',
            credentials: 'same-origin',
            body: JSON.stringify({
                method: VIZPORTAL_WEB_CLIENT_API_METHOD_NAME,
                params: params,
            })
        };
        var req = new Request(path, init);
        fetch(req).catch(function (error) { return console.error(error); });
    };
    FetchRequester.prototype.getHeaders = function () {
        var head = new Headers({
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        });
        if (this.sendAuthToken) {
            head.append(XSRF_TOKEN_HEADER_KEY, getXsrfToken());
        }
        return head;
    };
    return FetchRequester;
}());
exports.FetchRequester = FetchRequester;
var getXsrfToken = function () { return js_cookie_1.get(XSRF_TOKEN_COOKIE_KEY); };
//# sourceMappingURL=FetchRequester.js.map